export const initialJobs = [
  {
    id: 'job-1',
    title: 'Field Agronomist / Technical Officer',
    department: 'Agronomy & Field Services',
    location: 'Multan / South Punjab',
    type: 'Full Time',
    experience: '1-3 Years in Crop Advisory',
    qualification: 'B.Sc. / M.Sc. Agriculture (Agronomy / Entomology)',
    deadline: '2026-09-30',
    description: 'Provide technical agronomic guidance to farmers, conduct field demonstrations, and assist with product trials for wheat, cotton, and sugarcane crops.',
    postedAt: '2026-08-20'
  },
  {
    id: 'job-2',
    title: 'Area Sales Manager',
    department: 'Sales & Commercial',
    location: 'Punjab / Sindh Regions',
    type: 'Full Time',
    experience: '3-5 Years in Agro-Chemical Sales',
    qualification: 'BBA / MBA / B.Sc. Agriculture',
    deadline: '2026-09-25',
    description: 'Lead sales distribution networks, manage dealer relationships, and drive regional sales growth for pesticides, fertilizers, and micronutrients.',
    postedAt: '2026-08-18'
  },
  {
    id: 'job-3',
    title: 'Quality Assurance & Regulatory Specialist',
    department: 'Quality & Compliance',
    location: 'Multan Office',
    type: 'Full Time',
    experience: '2+ Years in QA / Chemistry',
    qualification: 'M.Sc. Chemistry / Agriculture Chemistry',
    deadline: '2026-10-05',
    description: 'Ensure formulation quality standards, oversee packaging compliance, and manage product registration documentation in accordance with agricultural regulations.',
    postedAt: '2026-08-15'
  },
  {
    id: 'job-4',
    title: 'Logistics & Supply Chain Coordinator',
    department: 'Operations',
    location: 'Multan Depot',
    type: 'Full Time',
    experience: '2+ Years in Warehouse / Logistics',
    qualification: 'Graduation / B.Com / Supply Chain Management',
    deadline: '2026-09-28',
    description: 'Coordinate timely dispatch of agricultural products to distribution centers and dealers across Pakistan during critical farming seasons.',
    postedAt: '2026-08-12'
  }
];

export const departmentOptions = [
  'Agronomy & Field Services',
  'Sales & Commercial',
  'Quality & Compliance',
  'Operations & Supply Chain',
  'Marketing & Brand Strategy',
  'Finance & Accounts',
  'Human Resources',
  'Research & Development'
];

export const jobTypeOptions = [
  'Full Time',
  'Part Time',
  'Contract',
  'Internship',
  'Remote / Field'
];

export const locationOptions = [
  'Multan / South Punjab',
  'Lahore / Central Punjab',
  'Faisalabad',
  'Khanewal / Sahiwal',
  'Rahim Yar Khan / Bahawalpur',
  'Sindh (Hyderabad / Sukkur)',
  'KPK (Peshawar / Swat)',
  'Head Office (Multan)',
  'All Pakistan (Field)'
];
